import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SidebarItem } from '../sidebar-item.component';

@Component({
  selector: 'app-sidebar-submenu-item',
  templateUrl: './sidebar-submenu-item.component.html',
  styleUrls: ['./sidebar-submenu-item.component.css'],
})
export class SidebarSubmenuItemComponent implements OnInit {
  @Input() item: SidebarItem;
  @Output() clicked = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onClick(subItem?: SidebarItem): void {
    const item = subItem || this.item;

    // Close item if subitem is clicked and has a function
    // Currently only language has subitems and we can
    // close once clicked. Change if needed if this changes.
    if (subItem && typeof subItem.fn === 'function') {
      this.item.expanded = false;
    }

    this.clicked.emit(item);
  }
}
